var React = require('react');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var IntlProvider = ReactIntl.IntlProvider;
var defaultMessages = require('../../i18n/messages/default');
var Footer = require('../Footer/Footer.js');
var Header = require('../Header/Header.js');
var createReactClass = require('create-react-class');
var PageCase = require('../PageCase/PageCase.js');

var Forbidden403 = createReactClass({

  displayName: 'Forbidden403',

  getInitialState() {
    return {
      localeId: this.props.localeId
    };
  },

  onLocalChange(localeId) {
    this.setState({ localeId: localeId });
  },

  renderFooter: function () {
    return (
      <IntlProvider locale={this.state.localeId}
        messages={this.props.translations}>
        <Footer {...this.props} locale={
          this.state.localeId
        } onLocalChange={this.onLocalChange} />
      </IntlProvider>
    )
  },


  renderLogo: function () {
    return (
      <div className='signedOutLogoContainer'>
        <center>
          <img className="iconResolution img-responsive" id='403' alt='403 Forbidden' src='assets/images/Img_403.png' />
        </center>
      </div>
    );
  },
  renderText: function () {
    return (
      <div className="signedOutTextContainer welcomeTitleCustomer">
        <h2 className="centreAligned ">
          <span>Identity and Access Management</span>
        </h2>
      </div>
    );
  },
  renderContent: function () {
    return (
      <div className="signedOutPage container" style={{ marginTop: '7%' }}>
        <div className="row">
          <div className="col-lg-3 col-md-3 col-sm-2"></div>
          <div className="col-lg-6 col-md-6 col-sm-8 col-xs-12">
            {this.renderLogo()}
            {this.renderText()}
            <div className="signedOutContainer text-center">
              <br />
              <div className="whiteContainer darkblue-text">
                <div className="font20bold">
                  {this.props.intl.formatMessage(defaultMessages['forbiddenMsg'])}
                  <br />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-2"></div>
        </div>
      </div>
    );
  },

  render: function () {
    return (
      <PageCase
        header={<Header />}
        content={this.renderContent()}
        footer={this.renderFooter()}>
      </PageCase>
    );
  }
});

module.exports = injectIntl(Forbidden403);